import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { SparklesIcon, CalendarIcon, InfoIcon } from 'lucide-react';

const UpdateItem = ({ title, date, description }) => (
  <Card className="shadow-sm border rounded-xl bg-white">
    <CardContent className="p-4 space-y-2">
      <div className="flex justify-between items-center">
        <h4 className="text-gray-800 font-semibold">{title}</h4>
        <div className="text-sm text-gray-400 flex items-center gap-1">
          <CalendarIcon size={14} />
          {date}
        </div>
      </div>
      <p className="text-sm text-gray-600">{description}</p>
    </CardContent>
  </Card>
);

const ClientWhatsNew = () => {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-gray-900 flex items-center gap-2">
        <SparklesIcon size={22} className="text-indigo-600" />
        What's New
      </h2>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <UpdateItem
          title="Mood Tracker Launched"
          date="June 2025"
          description="Easily track your daily mood and reflect on patterns that impact your well-being."
        />
        <UpdateItem
          title="Therapist Availability Sync"
          date="June 2025"
          description="Real-time sync of therapist calendars for faster session scheduling."
        />
        <UpdateItem
          title="New Resources Section"
          date="May 2025"
          description="Access free PDFs and tools to support your mental wellness journey."
        />
        <UpdateItem
          title="Premium Upgrade Options"
          date="May 2025"
          description="Gain access to exclusive content and direct therapist messaging."
        />
        <UpdateItem
          title="Video Call Enhancements"
          date="April 2025"
          description="Improved video quality and end-to-end encryption for Jitsi sessions."
        />
      </div>

      <div className="text-sm text-gray-500 text-center mt-6 flex items-center justify-center gap-2">
        <InfoIcon size={16} />
        Want to suggest a new feature? Let us know from your profile feedback tab.
      </div>
    </div>
  );
};

export default ClientWhatsNew;
